__webpack_require__.p = "./platform-sso-frontend/latest/";